import React from 'react'
import { Icons } from '../../../../Shared/Ant'
import { Typography, Tag } from 'antd'
import './styles.modules.scss'
import { Order } from '../../../../../models/order/order'
import OrderHelper from '../../../../../helpers/OrderHelper'
import { isDocumentNeededStatus } from './isDocumentNeededStatus'
import { ReportPostClosingError } from './ReportPostClosingError'
import { ApprovePostClosing } from './ApprovePostClosing'
import { get } from 'lodash'
import { ViewingUsers } from './ViewingUsers'
import { defaultSortOrder } from '../../../../../utils/table/defaultSortOrder'
import { columnSortTooltip } from '../../../../../utils/table/columnSortTooltip'
import { SORT_TEXTS } from '../../../../../constants/COLUMN_SORTER'

export const StatusColumnForPostClosing = (
  rootCompany: boolean,
  userPresences: object,
  sortColumn: string,
  sortOrder: string
) => {
  return {
    title: 'QC Status',
    dataIndex: 'status',
    defaultSortOrder: defaultSortOrder('status', sortColumn, sortOrder),
    showSorterTooltip: columnSortTooltip({
      dataIndex: 'status',
      sortColumn: sortColumn,
      sortOrder: sortOrder,
      ascText: SORT_TEXTS.PRIORITY_ASC,
      descText: SORT_TEXTS.PRIORITY_DESC,
      cancelText: SORT_TEXTS.CANCEL
    }),
    sorter: true,
    className: 'table-column status-column',
    render: (status: string | null, order: Order) => {
      return (
        <>
          {!rootCompany && OrderHelper.isPostClosingStatusPending(order) && (
            <>
              <ReportPostClosingError order={order} />
              <ApprovePostClosing order={order} />
            </>
          )}
          {OrderHelper.isPostClosingStatusRejected(order) && (
            <span>
              <Tag className="qc-rejected-tag">
                <Icons.ExclamationCircle className="rejected-icon" />
                QC errors detected
              </Tag>
              <div>
                <Typography.Text type="secondary">{order.mostRecentPostClosingReviewReasons}</Typography.Text>
              </div>
            </span>
          )}
          {OrderHelper.isPostClosingStatusApproved(order) && (
            <Tag className="qc-passed-tag">
              <Icons.CheckCircle />
              QC passed
            </Tag>
          )}
          {OrderHelper.isPostClosingStatusInProgress(order) && (
            <Tag className="qc-in-progress-tag">
              <Icons.ClockCircle />
              QC in progress
            </Tag>
          )}
          {OrderHelper.isPostClosingStatusNeedsQcReview(order) && (
            <Tag className="qc-needs-review-tag">
              <Icons.ClockCircle />
              Needs QC review
            </Tag>
          )}
          {isDocumentNeededStatus(order) && <Tag className="documents-note">Needs docs</Tag>}
          <ViewingUsers userPresence={get(userPresences, order.id)} />
        </>
      )
    }
  }
}
